<form>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>view_list</mat-icon>
      Audit Log for {{ListingName}}
    </h1>
  </section>
  <section mat-dialog-content class="content">
    @if (loading) {
      <mat-card class="loading">
        <mat-card-content>
          <mat-icon>autorenew</mat-icon>
          Loading&hellip;
        </mat-card-content>
      </mat-card>
    }
    @if (!loading) {
      @if (!logData.length) {
        <mat-card class="no-results">
          <mat-card-content>
            <mat-icon>sentiment_dissatisfied</mat-icon>
            No audit logs found.
          </mat-card-content>
        </mat-card>
      }
      @if (!!logData.length) {
        <mat-table #table [dataSource]="logData">
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          <ng-container matColumnDef="created">
            <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
            <mat-cell *matCellDef="let row"
              >{{row.created | date: "dd/MM/yy" }}</mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="userId">
              <mat-header-cell *matHeaderCellDef>User ID</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.user_id}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.name}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="email">
              <mat-header-cell *matHeaderCellDef>Email</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.email}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="message">
              <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
              <mat-cell *matCellDef="let row"
                >{{formatMessage(row.message)}}</mat-cell
                >
              </ng-container>
            </mat-table>
          }
        }
      </section>
    </form>
